import { Route } from '@angular/router';
import { authGuard } from '@/app/core/auth/guards/auth.guard';

export const routes: Route[] = [
  // Redirige la raíz directamente al login
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/sign-in',
  },

  // Auth — accesible solo si NO hay sesión activa
  {
    path: 'auth',
    loadChildren: () => import('./domains/auth/routes'),
  },

  // Admin — accesible solo si HAY sesión activa
  {
    path: 'admin',
    canActivate: [authGuard],
    loadChildren: () => import('./domains/admin/routes'),
  },

  // Coming soon
  {
    path: 'coming-soon',
    loadChildren: () => import('./domains/coming-soon/routes'),
  },

  // Liga — vista pública sin login (compartible por WhatsApp)
  {
    path: 'liga',
    loadChildren: () => import('./domains/league-public/routes'),
  },

  // Torneos — vista pública sin login (compartible por WhatsApp)
  {
    path: 'torneos',
    loadChildren: () => import('./domains/tournament-public/routes'),
  },

  // Ranking el Rey — vista pública sin login (compartible por WhatsApp)
  {
    path: 'ranking',
    loadChildren: () => import('./domains/ranking-public/routes'),
  },

  {
    path: 'clases',
    loadChildren: () => import('./domains/classes-public/routes'),
  },
];